module.exports = __webpack_public_path__ + "media/images/svgs/icon-caret-d0f41e656c1fe0ee2d649325aa6b1482.svg";